<template>
  <modal :show="show" @dismiss="dismiss" class="calculator-dialog" :class="{calced: isCalc}">
    <div class="modal-wrap">
      <div class="page-caption">
        <h3 class="title">计算器</h3>
      </div>
      <form class="form-horizontal form-custom" novalidate="novalidate" @submit.prevent="calc">
        <div class="row">
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">贷款总额：<span class="required">*</span></label>
              <div class="col-xs-9">
                <div class="input-group">
                  <input type="text" class="form-control" maxlength="15" v-model="amount"
                         @focus="amount = currency2number(amount)" @blur="amount = number2currency(amount)">
                  <span class="input-group-addon">元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">利率类型：</label>
              <div class="col-xs-9">
                <div class="addon-item"><input type="radio" name="rateType" :value="0" v-model.number="rateType"><span></span>年利率
                </div>
                <div class="addon-item" v-show="loanLifeType === 1"><input type="radio" name="rateType" :value="1" v-model.number="rateType"><span></span>月利率
                </div>
                <div class="addon-item" v-show="loanLifeType === 0"><input type="radio" name="rateType" :value="2" v-model.number="rateType"><span></span>日利率
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">贷款期限：<span class="required">*</span></label>
              <div class="col-xs-9">
                <div class="input-group">
                  <input type="number" class="form-control loan-life-text" min="0" :value="loanLife"
                         @change="setLoanLife" ref="loanLifeInp">
                  <div class="loan-life">
                    <div class="addon-item"><input type="radio" name="loanLife" :value="0" v-model="loanLifeType"><span></span>天
                    </div>
                    <div class="addon-item"><input type="radio" name="loanLife" :value="1" v-model="loanLifeType"><span></span>月
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <div class="loan-rate_more" :class="{'loan-rate_open': showLoanRate}">
                <div class="loan-rate-box" v-show="showLoanRate">
                  <label class="control-label col-xs-3">服务费率：<span class="required">*</span></label>
                  <div class="col-xs-9">
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="serviceRate"
                             @change="serviceRate = calcRate(serviceRate)">
                      <span class="input-group-addon">%</span>
                      <span class="input-group-addon input-group-loanrate iconfont"></span>
                    </div>
                  </div>
                </div>
                <div class="loan-rate-box" v-show="showLoanRate">
                  <label class="control-label col-xs-3">其他费率：<span class="required">*</span></label>
                  <div class="col-xs-9">
                    <div class="input-group">
                      <input type="number" class="form-control" v-model="otherRate"
                             @change="otherRate = calcRate(otherRate)">
                      <span class="input-group-addon">%</span>
                      <span class="input-group-addon input-group-loanrate iconfont"></span>
                    </div>
                  </div>
                </div>
                <div class="loan-rate-box">
                  <label class="control-label col-xs-3">贷款利率：<span class="required">*</span></label>
                  <div class="col-xs-9">
                    <div class="input-group">
                      <input type="number" class="form-control" v-model.number="loanRate"
                             @change="loanRate = calcRate(loanRate)">
                      <span class="input-group-addon">%</span>
                      <span class="input-group-addon input-group-loanrate iconfont"
                            @click="showLoanRate = !showLoanRate">&#xe619;</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">起息日：</label>
              <div class="col-xs-9">
                <div class="input-group">
                  <input type="text" class="form-control" v-model="startDay" ref="startDay" placeholder="起息日，选填">
                  <div class="input-alias" @click="showStartDatePicker"></div>
                  <datePicker
                    :is-show="isShowStartDate"
                    @select-date="setStartDay"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">基本天数：</label>
              <div class="col-xs-9" :class="{disabled: loanLifeType === 1}">
                <div class="addon-item"><input type="radio" name="basicDays" :value="360" v-model="basicDays" :disabled="loanLifeType === 1"><span
                  :class="{disabled: loanLifeType === 1}"></span>360天
                </div>
                <div class="addon-item"><input type="radio" name="basicDays" :value="365" v-model="basicDays" :disabled="loanLifeType === 1"><span
                  :class="{disabled: loanLifeType === 1}"></span>365天
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">到期日：</label>
              <div class="col-xs-9">
                <div class="input-group disabled">
                  <input type="text" class="form-control" v-model="endDay" ref="endDay" placeholder="到期日，选填">
                  <div class="input-alias" @click="showEndDatePicker"></div>
                  <datePicker
                    :is-show="isShowEndDate"
                    @select-date="setEndDay"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6">
            <div class="form-group">
              <label class="control-label col-xs-3">还款方式：</label>
              <div class="col-xs-9">
                <div class="input-group disabled">
                  <span class="pament-mode">到期还本付息</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6" v-show="isCalc">
            <div class="form-group bg">
              <label class="control-label col-xs-3">利息总额：</label>
              <div class="col-xs-9">
                <div class="input-group">
                  <div class="form-control decimal" style="line-height:60px;font-weight:normal;">
                    {{getDecimal(totalInterest)}}
                  </div>
                  <span class="input-group-addon">元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6" v-show="isCalc">
            <div class="form-group bg">
              <label class="control-label col-xs-3">服务费用：</label>
              <div class="col-xs-9">
                <div class="input-group">
                  <div class="form-control decimal" style="line-height:60px;font-weight:normal;">
                    {{getDecimal(totalService)}}
                  </div>
                  <span class="input-group-addon">元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6" v-show="isCalc">
            <div class="form-group bg">
              <label class="control-label col-xs-3">还款总额：</label>
              <div class="col-xs-9">
                <div class="input-group">
                  <div class="form-control decimal" style="line-height:60px;font-weight:normal;">
                    {{getDecimal(totalPament)}}
                  </div>
                  <span class="input-group-addon">元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6" v-show="isCalc">
            <div class="form-group bg">
              <label class="control-label col-xs-3">其他费用：</label>
              <div class="col-xs-9">
                <div class="input-group">
                  <div class="form-control decimal">{{getDecimal(totalOther)}}</div>
                  <span class="input-group-addon">元</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-wrap">
          <p class="err-wrap">{{errMsg}}</p>
          <div class="instructions">
            <span>使用说明？</span>
            <div class="instructions-detail">
              <p>本计算器分别以年利率或日利率（月利率）为基数进行计算以下举例均按基本天数360天为例。</p>
              <p>如按年利率计算：利息=贷款金额*年利率*期限/360</p>
              <p>按日利率计算：利息=贷款金额*日利率*期限</p>
              <p>以年利7%为例，日利率=7%/360=0.0195%，</p>
              <p>月利率=7%/12=0.5834%</p>
              <p>利息的计算结果保留至小数点后两位，小数点后第三位开始舍去。</p>
              <p>计算结果仅供参考。</p>
            </div>
          </div>
          <button type="submit" class="btn btn-primary" style="bottom:-30px" @click="calc">计&nbsp;&nbsp;算</button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/modal/modal'
  import DatePicker from '@/components/picker/date-new'
  import Vue from 'vue'
  export default {
    data () {
      return {
        amount: 0, // 贷款金额
        loanLife: 0, // 贷款期限
        loanLifeType: 0, // 贷款期限类型 0:按日计算；1:按月计算
        startDay: '', // 起息日
        endDay: '', // 到期日
        rateType: 0, // 利率类型 0:年利率；1:月利率； 2:日利率
        loanRate: 0, // 贷款利率
        serviceRate: 0, // 服务费率
        otherRate: 0, // 其他费率
        basicDays: 360, // 基本天数
        paymentType: 0, // 还款方式
        totalInterest: 0, // 利息总额
        totalPament: 0, // 还款总额
        totalService: 0, // 服务费用
        totalOther: 0, // 其他费用
        showLoanRate: false,
        isCalc: false,
        isShowStartDate: false,
        isShowEndDate: false,
        errMsg: ''
      }
    },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Modal,
      DatePicker
    },
    watch: {
      show (val) {
        if (val) {
          this.$nextTick(() => {
            if (window.getDomList && window.placeHolder) {
              window.getDomList('input[placeholder]').forEach((element) => {
                window.placeHolder(element, true)
              })
            }
          })
        }
      },
      loanLife () {
        if (isNaN(this.loanLife)) {
          this.loanLife = 0
        }
      },
      loanLifeType () {
        this.loanLife = 0
        this.startDay = ''
        this.endDay = ''
        // 设置利率利率类型
        if (this.rateType === 0) {
          return
        }
        this.loanLifeType === 0 ? this.rateType = 2 : this.rateType = 1
      }
    },
    created () {
      this.amount = this.number2currency(this.amount)
    },
    mounted () {
      this.loanLifeInp = this.$refs.loanLifeInp
    },
    methods: {
      dismiss (e) {
        this.init()
        this.$emit('dismiss', e)
      },
      init () {
        this.amount = 0
        this.loanLife = 0 // 贷款期限
        this.loanLifeType = 0 // 贷款期限类型 0:按日计算；1:按月计算
        this.startDay = '' // 起息日
        this.endDay = '' // 到期日
        this.rateType = 0 // 利率类型 0:年利率；1:月利率； 2:日利率
        this.loanRate = 0 // 贷款利率
        this.serviceRate = 0 // 服务费率
        this.otherRate = 0 // 其他费率
        this.basicDays = 360 // 基本天数
        this.paymentType = 0 // 还款方式
        this.totalInterest = 0 // 利息总额
        this.totalPament = 0 // 还款总额
        this.totalService = 0 // 服务费用
        this.totalOther = 0 // 其他费用
        this.showLoanRate = false
        this.isCalc = false
        this.isShowStartDate = false
        this.isShowEndDate = false
        this.errMsg = ''
      },
      dateStrFormat (dateStr) {
        return dateStr.split('-').map((v) => {
          return parseInt(v)
        })
      },
      dateFormate (date) {
        return date.getFullYear() + '-' + this.addZero(date.getMonth() + 1) + '-' + this.addZero(date.getDate())
      },
      addZero (num) {
        return num < 10 ? '0' + num : '' + num
      },
      currency2number (currency) {
        return Vue.filter('unformat')(currency + '')
      },
      number2currency (number, length = 2, prefix = '') {
        return Vue.filter('currency')(number, prefix, length)
      },
      toFixed (number, length = 2) {
        number = number.toFixed(length + 1)
        Math.ceil(number)
        return Vue.filter('tofixed')(number, length)
      },
      calc () {
        this.isShowStartDate = false
        this.isShowEndDate = false
        if (this.validate()) {
          this.totalInterest = this.calcInterest(this.loanRate)
          this.calcTotalPament()
          this.totalService = this.calcInterest(this.serviceRate)
          this.totalOther = this.calcInterest(this.otherRate)
          this.isCalc = true
        }
      },
      validate () {
        if (this.currency2number(this.amount) <= 0) {
          this.errMsg = '请输入贷款金额'
          return false
        }
        if (this.loanLife === 0) {
          this.errMsg = '请输入贷款期限'
          return false
        }
        if (this.currency2number(this.loanRate) <= 0) {
          this.errMsg = '贷款利率必须大于0'
          return false
        }
        this.errMsg = ''
        return true
      },
      calcRate (rate) {
        rate = Number(rate)
        // 先保存整数部分
        let integer = parseInt(rate)
        let decimal = (rate - integer).toFixed(7)
        let index = decimal.indexOf('.')
        if (index !== -1) {
          decimal = decimal.substr(2) * 0.1
          decimal = Math.ceil(decimal) * Math.pow(10, -6)
        }
        return +(integer + decimal).toFixed(6)
      },
      calcInterest (rate) {
        // 以年利7%为例，日利率=7%/360=0.0195%，
        // 月利率=7%/12=0.5834%
        // 利息的计算结果保留至小数点后两位，小数点后第三位向上进位。
        let amount = this.currency2number(this.amount)
        rate = rate / 100
        let total = 0
        if (this.rateType === 0) { // 年利计算
          // 按年利率计算：贷款金额*年化利率*借款期限（天/月）/360（12）=利息（保留小数点后两位，小数点后第3位开始舍去）；
          if (this.loanLifeType === 0) {
            total = amount * this.loanLife * this.calcRate(rate / this.basicDays)
          } else {
            total = amount * this.loanLife * this.calcRate(rate / 12)
          }
        } else if (this.rateType === 1) { // 月利计算
          // 按月利率计算：贷款金额*月利率*借款月数=利息（保留小数点后两位，小数点后第3位开始舍去）；
          total = this.toFixed(amount * rate * this.loanLife, 3)
        } else { // 日利计算
          // 按日利率计算：贷款金额*日利率*借款天数=利息（保留小数点后两位，小数点后第3位开始舍去）；
          total = this.toFixed(amount * rate * this.loanLife, 3)
        }
        return Number(total)
      },
      getDecimal (money) {
        let str = money.toFixed(3)
        if (money === 0) {
          return '---'
        }
        return str.substr(0, str.length - 1)
      },
      calcTotalPament () { // 计算还款总额
        // 还款总额 = 贷款金额+利息总额
        this.totalPament = this.currency2number(this.amount) + this.currency2number(this.totalInterest)
      },
      showStartDatePicker () {
        if (this.isShowEndDate) {
          this.isShowEndDate = false
        }
        this.isShowStartDate = !this.isShowStartDate
      },
      showEndDatePicker () {
        if (this.isShowStartDate) {
          this.isShowStartDate = false
        }
        this.isShowEndDate = !this.isShowEndDate
      },
      setLoanLife () {
        this.loanLifeInp.value = parseInt(this.loanLifeInp.value)
        this.loanLife = parseInt(this.loanLifeInp.value)
        if (!this.startDay && !this.endDay) {
          return
        } else if (!this.startDay && this.endDay) { // 起息日为空
          this.startDay = this.calcStartDay()
        } else if (this.startDay && !this.endDay) { // 到期日为空
          this.endDay = this.calcEndDay()
        } else { // 起息日,到期日都不为空，计算到期日
          this.endDay = this.calcEndDay()
        }
      },
      setStartDay (year, month, date) {
        this.isShowStartDate = false
        this.startDay = year + '-' + month + '-' + date
        if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
          let oWrapper = this.$refs.startDay.previousElementSibling
          oWrapper.style.display = 'none'
        }
        if (!this.loanLife && !this.endDay) {
          return
        } else if (!this.loanLife && this.endDay) { // 贷款期限为空
          this.loanLife = this.calcLoanLife()
        } else if (this.loanLife && !this.endDay) { // 到期日为空
          this.endDay = this.calcEndDay()
        } else { // 贷款期限,到期日都不为空，计算到期日
          this.endDay = this.calcEndDay()
        }
      },
      setEndDay (year, month, date) {
        this.isShowEndDate = false
        this.endDay = year + '-' + month + '-' + date
        if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
          let oWrapper = this.$refs.endDay.previousElementSibling
          oWrapper.style.display = 'none'
        }
        if (!this.startDay && !this.loanLife) {
          return
        } else if (!this.startDay && this.loanLife) { // 起息日为空
          this.startDay = this.calcStartDay()
        } else if (this.startDay && !this.loanLife) { // 贷款期限为空
          this.loanLife = this.calcLoanLife()
        } else { // 贷款期限,起息日都不为空，计算起息日
          this.startDay = this.calcStartDay()
        }
      },
      calcLoanLife () {
        if (this.loanLifeType === 0) {
          // 按天机算
          let rangeTime = new Date(this.endDay) - new Date(this.startDay)
          this.loanLife = Math.floor(rangeTime / 1000 / 3600 / 24)
          if (this.loanLife < 0) {
            this.errMsg = '到期日不能小于起息日'
            this.loanLife = 0
            this.startDay = ''
            this.endDay = ''
          } else if (this.loanLife === 0) {
            this.errMsg = '贷款期限最低为1天'
            this.loanLife = 0
            this.startDay = ''
            this.endDay = ''
          }
        } else {
          // 按月计算，只有贷款期限为空或者为0才会计算到这里
          let dateArr1 = this.dateStrFormat(this.startDay)
          let dateArr2 = this.dateStrFormat(this.endDay)
          this.loanLife = dateArr2[1] - dateArr1[1]
          if (this.loanLife === 0) {
            this.loanLife = 1
            let year = dateArr1[0]
            let month = parseInt(dateArr1[1]) + 1
            if (month > 12) {
              year++
              month = month % 12
            }
            let day = dateArr1[2]
            let date = new Date(year + '-' + this.addZero(month) + '-' + this.addZero(day))
            this.endDay = this.dateFormate(date)
          }
        }
        return this.loanLife
      },
      calcStartDay () {
        if (this.loanLifeType === 0) {
          // 按天机算
          let date = new Date(new Date(this.endDay).getTime() - this.loanLife * 24 * 60 * 60 * 1000)
          this.startDay = this.dateFormate(date)
        } else {
          // 按月计算
          let dateArr = this.dateStrFormat(this.endDay)
          let year = Math.floor((dateArr[0] * 12 + dateArr[1] - this.loanLife) / 12)
          let month = (dateArr[0] * 12 + dateArr[1] - this.loanLife) % 12
          if (month === 0) {
            month = 12
          }
          let date = new Date(year + '-' + this.addZero(month) + '-' + this.addZero(dateArr[2]))
          this.startDay = this.dateFormate(date)
        }
        return this.startDay
      },
      calcEndDay () {
        if (this.loanLifeType === 0) {
          // 按天机算
          let date = new Date(new Date(this.startDay).getTime() + this.loanLife * 24 * 60 * 60 * 1000)
          this.endDay = this.dateFormate(date)
        } else {
          // 按月计算
          let dateArr = this.dateStrFormat(this.startDay)
          let year = dateArr[0] + Math.floor((this.loanLife + dateArr[1]) / 12)
          let month = (dateArr[1] + this.loanLife) % 12
          let date = new Date(year + '-' + this.addZero(month) + '-' + this.addZero(dateArr[2]))
          this.endDay = this.dateFormate(date)
        }
        return this.endDay
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .calculator-dialog
    .dialog-outer
      .dialog-inner
        .modal-wrap
          // padding 15px 0 20px
          .point
            margin 8px auto
        .form-custom
          position relative
          width 800px
          font-size 16px
          background #fff
          color #224a6c
    /*.shadow*/
    /*position: absolute*/
    /*left 0*/
    /*top 0*/
    /*right 0*/
    /*bottom 0*/
    /*background-color #f90*/
    /*z-index 11*/
    .form-custom.form-horizontal
      .btn-wrap
        padding 4px 60px 10px
      .err-wrap
        height 22px
      .form-group
        height 60px
        margin-left 0
        margin-right 0
        &.bg
          background-color #e9f6ff
        input:
        :-webkit-outer-spin-button, input::-webkit-inner-spin-button
          -webkit-appearance none !important
          -moz-appearance textfield
          margin: 0
        .form-control
          padding-top 0
          padding-bottom 0
          &.decimal
            line-height 60px
            font-weight normal
      .input-group
        padding-left 10px
        .input-alias
          width 100%
          height 100%
          position absolute
          left 0
          top 0
          right 0
          bottom 0
          z-index 10
          background-color rgba(255, 255, 255, 0)
          cursor auto
        .input-group-loanrate.iconfont
          width 44px
          font-size 20px
          color rgba(78, 209, 255, 1)
          cursor pointer
      .control-label
        width 25% !important
        display block
        padding-top 0
        height 60px
        line-height 60px
        text-align right
        position relative
        .required
          position absolute
          color orangered
          line-height 60px
          // right 0
          top 0
          font-size 14px
      .col-xs-3
        padding-left 0
        padding-right 0
      .col-xs-9
        padding-left 0
        padding-right 0
      .disabled
        color #7084a4 !important
    .loan-rate_more
      position absolute
      left 10px
      // padding-left 14px
      width 364px
      bottom 1px
      background-color #fff
      border 1px solid transparent
      z-index 10
      &.loan-rate_open
        border 1px solid rgba(42, 159, 250, 0.4);
        box-shadow 0 2px 5px rgba(33, 70, 104, .34)
      .loan-rate-box
        height 56px
        border-bottom 1px solid rgba(107, 125, 142, 0.1)
        &:last-child
          border-bottom none
          position relative
          top 1px
    .row
      margin-right 0
      margin-left 0
    .col-xs-6
      height 60px
      padding-left 0
      padding-right 0
      &:nth-child(2n+1)::after
        content ''
        width 0
        height 34px
        position absolute
        top 18px
        right 0
        border-right 1px dashed #C1C1C1
      .addon-item
        float left
        height 56px
        line-height 56px
        position relative
        padding-left 30px
        & + .addon-item
          margin-left 10px
        span
          position absolute
          left 10px
          top 24px
          display block
          width 14px
          height 14px
          border-radius 50%
          border 1px solid rgba(78, 209, 255, 1)
          background-color: #fff;
          &.disabled
            border-color #7084a4
        input
          left 10px
          top 24px
          position absolute
          opacity 0
          width 14px
          height 14px
          z-index 2
          margin 0
          &:checked + span::after
            content ''
            position absolute
            top 2px
            left 2px
            width 8px
            height 8px
            border-radius 50%
            background-color rgba(78, 209, 255, 1)
          &:checked + span.disabled::after
            background-color #7084a4
      .pament-mode
        display block
        height 56px
        line-height 56px
        font-size 14px
      .loan-life-text
        width 120px !important
    .instructions
      width 92px
      height 20px
      position absolute
      right 0
      z-index 10
      bottom 5px
      font-size 12px
      &:hover
        .instructions-detail
          display block
      > span
        cursor pointer
        display block
        color #2a9ffa
        width 92px
        height 20px
        text-decoration underline
      .instructions-detail
        display none
        position absolute
        bottom 40px
        left -158px
        width 400px
        border-radius 4px
        background-color rgba(60, 60, 60, .8)
        color #fff
        padding 10px
        transition all 0.4s
        &::after
          content ''
          display block
          position absolute
          border-width 10px
          border-style solid
          border-color rgba(60, 60, 60, .8) transparent transparent transparent
          bottom -20px
          left 50%
          margin-left -10px
        p
          margin 0
          padding 0
          font-size 14px
          line-height 20px
</style>



// WEBPACK FOOTER //
// calculator-new.vue?02606b25